<template lang='pug'>
  .rsv-msg.component.confirmable-container(
    :class='klass'
  )
    .message-container.container(v-if='msg.cancellation')
      rsv-stamp(
        v-if='voided'
        :text='$t("VOID")'
      )
      rsv-stamp(
        v-if='msg.cancellation.confirmed'
        :text='$t("CONFIRMED")'
      )
      .meta
        span.sender {{ msg.sent.by.name }}
        span.date {{ msg.sent.on.toDate().toLocaleString() }}
      .message {{ msg.content }}
      bf-flex.centered.retain-btn(
        v-if='retainable'
        @click.native='retain'
      )
        close-icon

      bf-flex.buttons
        label {{ $t('Cancellation Request') }}
        bf-button.confirm-btn(
          v-if='confirmable && !voided && !msg.cancellation.confirmed'
          @click.native='confirm'
        )
          template(v-slot:text) {{ $t('Confirm') }}

        //- bf-button.confirmed-tag(v-if='msg.cancellation.confirmed')
        //-   template(v-slot:text) {{ $t('Confirmed') }}

    .message-container.container(v-else)
      .meta
        span.sender {{ msg.sent.by.name }}
        span.date {{ msg.sent.on.toDate().toLocaleString() }}
      .message {{ msg.content }}
</template>

<script>
  import { db } from '@/main'

  export default {
    name: 'rsv-msg.component',

    props: ['msg', 'rsv', 'account'],

    data() {
      return {
        // rsv: {}
        key: 0
      }
    },

    // firestore() {
    //   return {
    //     rsv: db.collection('reservations').doc( this.rsv.id )
    //   }
    // },

    computed: {
      klass() {
        return {
          voided: this.voided,
          merchant: this.msg.sent.by.id != this.rsv.account_id,
          cancellation: this.msg.cancellation,
          mine: this.mine,
          theirs: this.theirs
        }
      },

      mine() {
        return this.account.id == this.msg.sent.by.id
      },

      theirs() {
        return !this.mine
      },

      perspective() {
        return this.account.id == this.rsv.account_id ?
          { customer: true } :
          { customer: false }
      },

      requested() {
        return this.msg.sent.by.id == this.rsv.account_id ?
          { by: { customer: true } } :
          { by: { customer: false } }
      },

      confirmable() {
        return this.account.id != this.msg.sent.by.id
      },

      retainable() {
        return !this.msg.cancellation.voided && this.account.id == this.msg.sent.by.id && !this.msg.cancellation.confirmed
      },

      voided() {
        return this.msg.cancellation.voided
      }
    },

    methods: {
      retain() {
        db.collection('reservations').doc( this.rsv.id ).collection('messages').doc( this.msg.id ).update({
          cancellation: {
            confirmed: false,
            voided: true
          }
        })
        db.collection('reservations').doc( this.rsv.id ).update( {status: 'Active'} )
      },

      confirm() {
        db.collection('reservations').doc( this.rsv.id ).collection('messages').doc( this.msg.id ).update({
          cancellation: {
            confirmed: {
              on: new Date(),
              by: this.account
            }
          }
        })
        db.collection('reservations').doc( this.rsv.id ).update({ status: 'Canceled' })
      }
    }
  }
</script>

<style scoped lang='stylus'>
  .rsv-msg
    border-radius 5px
    font-size .96em
    background rgb( 250 250 250 )
    margin 12px 0
    border-radius 5px
    width 88%
    border 1px solid rgba( 128 128 128 .1 )
    &.theirs
      margin-right auto
    &.mine
      margin-left auto
    &.merchant
      background rgb( 255 240 225 )
      color inherit
    &.cancellation
      border 1.5px solid
      box-shadow var(--shadow-box-shallow)
    &.voided
      box-shadow none
      border-color rgba( 0 0 0 .2 )

    .section-heading
      padding 8px

    .message-container.container
      .meta
        border-bottom 1px solid rgba( 0 0 0 .04 )
        padding 8px
        .date
          font-size .88em
        .sender
          font-weight bold
          margin-right 8px

      .message
        border-top 1px solid rgba( 255 255 255 .3 )
        border-bottom 1px solid rgba( 0 0 0 .04 )
        padding 21px 8px

      .buttons
        padding 4px 4px 4px 8px
        border-top 1px solid rgba( 255 255 255 .3 )
        align-items center
        label
          font-weight bolder
          margin-right auto

    .retain-btn
      position absolute
      top -6px
      right -6px
      font-size 1.2em
      background var(--clr-text)
      color white
      border-radius 50%
      height 23px
      width 24px
      padding-left 1px
      padding-bottom 2px

    .confirm-btn, .confirmed-tag
      margin-left auto
      background rgb( 64 64 64 )
      padding 4px 12px
      border-radius 3px
      width auto

    // .confirmed-tag
    //   background rgb( 240 160 0 )
</style>
